module.exports = __webpack_public_path__ + "static/images/logo-ubisoft.2ffbcdddec9ee6fecac9527a6ef66a2d.png";